module.exports = __webpack_public_path__ + "static/media/miscellaneous.fcf3f9a9.png";